export default __webpack_public_path__ + "static/soc-2-implementation-saas-companies-93aedeb5fd64815c5ad59e3daddc9041.jpg";